// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".phone-reg-box .van-field__control {\n  font-size: 0.42667rem;\n  font-weight: 400;\n}\n.phone-reg-box .van-cell::after {\n  border: 0.01333rem dotted #858585;\n}\n", ""]);
// Exports
module.exports = exports;
